module.exports = __webpack_public_path__ + "img/atulverma.247c0d55.png";